import {combineReducers} from "redux";

import dataReducer from "./features/data/dataSlice";

export const rootReducer = combineReducers({
  data: dataReducer,
});
